'use client'

import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import * as Sentry from '@sentry/nextjs'
import cx from 'classnames'
import { useEffect, useState } from 'react'

import ButtonLink from 'components/ButtonLink'
import Page from 'components/Page'
import { IS_BRAND_PULSZ } from 'config/brands'
import ROUTES from 'config/routes.json'
import ProductGameTile from 'containers/ProductGameTile'
import useGames from 'hooks/useGames'
import { useGuestVisibleGames } from 'hooks/useGuestVisibleGames'
import content from 'prismic-translates/common.json'
import { setTopGames } from 'utils/loadGameInfoGetInitialProps'

import classes from './styles.module.scss'

import type { GameProduct } from '@patrianna/shared-patrianna-types/store/GameModule'

const t = getTranslationFromJson([content])
const COUNT_GAMES = 4

export default function Custom404() {
  const [isLoading, setIsLoading] = useState(true)
  const [products, setProducts] = useState<GameProduct[]>([])
  const [layout, setLayout] = useState<string>('')

  // PLDV-8941: loads the catalogue so `useGuestVisibleGames` can resolve blocked codes.
  useGames()
  const { games, isResolving } = useGuestVisibleGames(products)

  const isGamesAvailable = games.length > 0
  const titleText = IS_BRAND_PULSZ ? t('page_not_found_title') : t('page_not_found_title_pulszbingo')

  useEffect(() => {
    if (isLoading) {
      Sentry.captureMessage(`Page ${window.location.href} not found`)
      setTopGames(COUNT_GAMES, setIsLoading, setProducts, setLayout)
    }
  }, [isLoading])

  return (
    <Page className={classes.root}>
      <img
        className={classes.icon}
        src={`${process.env.IMG_ORIGIN}/common/not-found.svg`}
        width={263}
        height={175}
        alt='not-found-page-icon'
      />
      <h3 className={classes.title} data-testid='error-title'>
        {titleText}
      </h3>
      {/*For analytics purposes, do not remove*/}
      <span style={{ display: 'none' }} id={'analytics_error_page'}></span>
      {isGamesAvailable && <p className={classes.description}>{t('page_not_found_description')}</p>}

      {isLoading || isResolving ? (
        <div className={classes.games}>
          {Array(COUNT_GAMES)
            .fill(true)
            .map((el, index) => (
              <div key={index} className={classes.skeletonBox}></div>
            ))}
        </div>
      ) : (
        isGamesAvailable && (
          <div className={classes.games}>
            {games.map((game, index) => (
              <ProductGameTile
                game={game}
                key={game.code}
                gameIndex={index + 1}
                className={classes.gameRoot}
                refererPath='404'
                layout={layout}
              />
            ))}
          </div>
        )
      )}
      <ButtonLink
        className={cx(classes.button, !isGamesAvailable && classes.noGamesAvailable)}
        variant='contained'
        href={ROUTES.HOME}
        data-testid='home-button'
      >
        {t('go_to_home_btn')}
      </ButtonLink>
    </Page>
  )
}
